
        var result = require("!!../../../../../node_modules/css-loader/index.js!./electricity-dashboard.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/electricity/electricity-dashboard/electricity-dashboard.component.css
// module id = 663
// module chunks = 0